/**
 * Culture Agent URL bases: local dev uses `/api` via setupProxy; production calls go
 * directly to the service's base URL (e.g. `REACT_APP_CULTURE_AGENT_API_HOST`).
 */

/** In development, empty string (same origin + setupProxy). Otherwise optional absolute base from env. */
export function cultureAgentApiHost(): string {
  return process.env.NODE_ENV === 'development' ? '' : process.env.REACT_APP_CULTURE_AGENT_API_HOST ?? '';
}

export function cultureAgentAuthBase(): string {
  return '/api/auth';
}

export function cultureAgentCoreBase(): string {
  return '/api/core';
}

/**
 * Core paths — keep trailing slashes consistent with the backend. A 301/302 from a
 * missing slash can trigger a second cross-origin hop; redirect responses often lack
 * CORS headers, which surfaces as “blocked / Access-Control-Allow-Origin missing”.
 */
export const cultureAgentCorePaths = {
  getResults: '/get-results/',
  stream: '/stream/',
  reset: '/reset/',
  companyMatchResult: '/company-match-result/',
} as const;

/** Join optional origin host (no trailing slash) with an absolute path. */
export function cultureAgentJoinUrl(apiHost: string, path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiHost}${normalizedPath}`;
}
